import { mount } from '@/mounter'

import SanitasHealthForecastQuestionnaire from './HealthForecastQuestionnaire'

const config = window.Sanitas?.healthForecastQuestionnaireConfig || {}
mount(
  'health-forecast-questionnaire',
  SanitasHealthForecastQuestionnaire,
  config,
)
